var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",on:{"click":_vm.clickOutSide}},[_c('side-bar',[_c('template',{slot:"topLogo"},[_c('span',{staticClass:"rounded-circle d-flex flex-column align-items-center"},[_c('img',{staticStyle:{"max-width":"120px"},attrs:{"alt":"Image placeholder","src":`${_vm.publicPath}/img/rcp/${_vm.theme}-dashboard-logo.png`}})])]),_c('template',{slot:"links"},[(
          _vm.isFirstTime == 'false' &&
          _vm.kycApprove &&
          _vm.haveCard &&
          !_vm.profileStatus &&
          _vm.domain_info.merchant_deposit != 1 &&
          _vm.domain.indexOf('gvv.oripay.us')===-1
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Deposit',
          path: '/choose-card',
          imageicon: 'deposit.svg',
        }}}):_vm._e(),(
          _vm.isFirstTime == 'false' &&
          _vm.kycApprove &&
          _vm.haveCard &&
          !_vm.profileStatus &&
          _vm.isNavActive
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Transfer',
          path: '/transfer',
          imageicon: 'transfer.svg',
        }}}):_vm._e(),(!_vm.isSuspend && _vm.isFirstTime == 'false' && !_vm.profileStatus)?_c('sidebar-item',{attrs:{"link":{
          name: 'Upload Documents (eKYC)',
          path: _vm.kycApprove ? '/kyc-summary' : '/kyc',
          imageicon: 'ekyc.svg',
        }}}):_vm._e(),(
          !_vm.isSuspend && _vm.isFirstTime == 'false' && _vm.kycApprove && !_vm.profileStatus
        )?_c('sidebar-item',{attrs:{"link":{
          name: 'Card Management',
          path: '/card-management',
          imageicon: 'card-management.svg',
        }}}):_vm._e(),(!_vm.isSuspend)?_c('sidebar-item',{attrs:{"link":{
          name: 'Settings',
          path: '/settings',
          imageicon: 'settings.svg',
        }}},[(_vm.isFirstTime == 'false')?_c('sidebar-item',{attrs:{"link":{
            name: 'Edit Profile',
            path: '/edit-profile',
          }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
            name: 'Change Password',
            path: '/change-password',
          }}}),(_vm.isFirstTime == 'false')?_c('sidebar-item',{attrs:{"link":{
            name: 'System Configuration',
            path: '/system-configuration',
          }}}):_vm._e()],1):_vm._e(),(!_vm.isSuspend && _vm.isFirstTime == 'false' && _vm.kycApprove)?_c('sidebar-item',{attrs:{"link":{
          name: 'Report',
          path: '/transaction',
          imageicon: 'report.svg',
        }}}):_vm._e(),(!_vm.isSuspend && _vm.chat == 1)?_c('sidebar-item',{attrs:{"link":{
          name: 'Customer Service',
          path: '/cs',
          imageicon: 'customer-service.svg',
        }}}):_vm._e(),(!_vm.isSuspend && _vm.chat == 1)?_c('sidebar-item',{attrs:{"link":{
          name: 'FAQs',
          path: '/faq',
          imageicon: 'faq.svg',
        }}}):_vm._e(),_c('sidebar-item',{attrs:{"link":{
          name: 'Logout',
          path: '/logout',
          imageicon: 'logout.svg',
        }}})],1)],2),_c('div',{staticClass:"main-content"},[_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('notifications',{attrs:{"position":"top right"}}),_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view',{ref:"currentPage"})],1),(_vm.chat == 1 && !_vm.visibleChat)?_c('floating-chat-icon',{attrs:{"icon":"","isActive":_vm.showChat},on:{"toggle-chat":_vm.toggleChat}}):_vm._e(),(!_vm.visibleChat && _vm.showChat && _vm.chat == 1)?_c('floating-chat',{attrs:{"isFloating":true},on:{"toggle-chat":_vm.toggleChat,"is-connect":_vm.isReadyToChat}}):_vm._e()],1)]),_c('b-modal',{attrs:{"id":"modal-scarm-alert","title":`${_vm.$t('Reminder')}`,"hide-footer":""},on:{"hide":function($event){return _vm.$bvModal.hide('modal-scarm-alert')}},scopedSlots:_vm._u([{key:"modal-title",fn:function(){return [_c('h3',{staticClass:"text-title fz-18"},[_vm._v(_vm._s(_vm.$t("Reminder")))])]},proxy:true}])},[_c('div',{staticClass:"mt-4 text-center"},[_c('img',{staticClass:"w-100",staticStyle:{"max-width":"320px"},attrs:{"alt":"Image placeholder","src":`${_vm.publicPath}/img/rcp/scam_alert.gif`}}),_c('h2',[_vm._v("Scam Alert")]),_c('p',{staticClass:"mx-4"},[_vm._v("\n        Members of the public are reminded not to disclose your personal\n        identification numbers (PIN) and passwords to third parties under any\n        circumstance. RCPAY LIMITED will NEVER request for personal financial\n        information or confirmation of Mastercard transactions through\n        telephone calls, emails or SMS. Please do not respond to such query.\n        "),_c('br'),_vm._v("\n        Do NOT reveal your personal financial information.\n      ")]),_c('button',{staticClass:"btn btn-orange my-4",on:{"click":function($event){return _vm.$bvModal.hide('modal-scarm-alert')}}},[_vm._v("\n        "+_vm._s(_vm.$t("I understand"))+"\n      ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }